export default {
	"vehicleTrack": {
		"DateTime": "日期时间"
	},
	"zdTrack": {
		"reanalysis": "重新分析",
		"send": "发",
		"sendTo": "发往",
		"receive": "收"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/components/zdTrack/zdTrack.js